import {useEffect, useState} from "react";
import { Button } from "react-bootstrap";

export const filterOptions = ["House","Neighbor","Street","Driveway"];

// Look for user data in session storage
export const getUser = () => {
    let userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    else {
        userStr = sessionStorage.getItem('user');
        if (userStr) return JSON.parse(userStr);
        else return null;
    }
}

// Look for token in session storage
export const getToken = () => {
    let token = localStorage.getItem('token') || null;
    if(!token) {
        token = sessionStorage.getItem('token') || null;
    }
    return token;
}

// Look for camera token in session storage
export const getCameraToken = () => {
    try {
        return JSON.parse(sessionStorage.getItem('cameraToken')) || null;
    } catch(e) {
        return sessionStorage.getItem('cameraToken') || null;
    }
}

export const setCameraToken = (t) => {
    sessionStorage.setItem('cameraToken',JSON.stringify(t));
}

export const setCameras = (cameras) => {
    sessionStorage.setItem('cameras',JSON.stringify(cameras));
}

export const getCameras = () => {
    return JSON.parse(sessionStorage.getItem('cameras')) || null;
}

export const storeCap = (cap) => {
    sessionStorage.setItem('cap',JSON.stringify(cap));
}

export const getCap = () => {
    const cap = sessionStorage.getItem('cap');
    if(!cap || cap == null || typeof cap === "undefined") {
        return null;
    } else {
        return JSON.parse(sessionStorage.getItem('cap')) || null;
    }
}

export const storeFiles = (files) => {
    sessionStorage.setItem('files',JSON.stringify(files));
}

export const getFiles = () => {
    return JSON.parse(sessionStorage.getItem('files')) || null;
}

export const storeLatestUrls = (urls) => {
    sessionStorage.setItem('urls',JSON.stringify(urls));
}

export const getLatestUrls = () => {
    return JSON.parse(sessionStorage.getItem('urls')) || null;
}

export const getDefaultEventTabs = () => {
    return JSON.parse(sessionStorage.getItem('defaultEventTabs')) || null;
}

export const setDefaultEventTabs = (tabs) => {
    sessionStorage.setItem('defaultEventTabs',JSON.stringify(tabs));
}

export const getDefaultEventParameters = () => {
    var ep = JSON.parse(sessionStorage.getItem('defaultEventParameters')) || null;
    for(var cap in ep) {
        if(ep[cap].startDate) {
            ep[cap].startDate = new Date(ep[cap].startDate);
        }
        if(ep[cap].endDate) {
            ep[cap].endDate = new Date(ep[cap].endDate);
        }
    }
    return ep;
}

export const setDefaultEventParameters = (params) => {
    sessionStorage.setItem('defaultEventParameters',JSON.stringify(params));
}

export const removeDefaultEventParameters = () => {
    sessionStorage.removeItem('defaultEventParameters');
}

export const getDefaultFrameParameters = () => {
    return JSON.parse(sessionStorage.getItem('defaultFrameParameters')) || null;
}

export const setDefaultFrameParameters = (params) => {
    sessionStorage.setItem('defaultFrameParameters',JSON.stringify(params));
}

export const getDefaultPageNumber = () => {
    return JSON.parse(sessionStorage.getItem('defaultPageNumber')) || null;
}

export const setDefaultPageNumber = (pn) => {
    sessionStorage.setItem('defaultPageNumber',JSON.stringify(pn))
}

export const setDefaultCameraDirections = (dirs) => {
    sessionStorage.setItem('defaultCameraDirections',JSON.stringify(dirs));
}

export const getDefaultCameraDirections = (dirs) => {
    return JSON.parse(sessionStorage.getItem('defaultCameraDirections')) || null;
}

export const getDefaultSortParameter = () => {
    return JSON.parse(sessionStorage.getItem('defaultSortParameter')) || null;
}

export const setDefaultSortParameter = (sp) => {
    sessionStorage.setItem('defaultSortParameter',JSON.stringify(sp));
}

export const getDefaultDaylightParameter = () => {
    return JSON.parse(sessionStorage.getItem('defaultDaylightParameter')) || null;
}

export const setDefaultDaylightParameter = (dp) => {
    sessionStorage.setItem('defaultDaylightParameter',JSON.stringify(dp));
}

export const setNewCapSignup = (su) => {
    sessionStorage.setItem('newCapSignup',JSON.stringify(su));
}

export const getNewCapSignup = () => {
    return JSON.parse(sessionStorage.getItem('newCapSignup')) || false;
}

export const setFCMToken = (t) => {
    sessionStorage.setItem('fcmToken',JSON.stringify(t));
}

export const retrieveFCMToken = () => {
    return JSON.parse(sessionStorage.getItem('fcmToken'));
}

// remove the token and user from the ssion storage
export const removeUserSession = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
}

// set the token from storage
export const setUserSession = (token, user) => {
    sessionStorage.setItem('token',token);
    sessionStorage.setItem('user',JSON.stringify(user));
    localStorage.setItem('token',token);
    localStorage.setItem('user',JSON.stringify(user));
} 

export const salesClick = () => {
    window.open("https://bedrockwireless.com/",'_blank');
}

export const getNeighborhoodCollapsed = () => {
    return JSON.parse(sessionStorage.getItem('neighborhoodCollapsed')) || null;
}

export const storeNeighborhoodCollapsed = (nc) => {
    sessionStorage.setItem('neighborhoodCollapsed',JSON.stringify(nc));
}

export const reformatDate = (d,timeZone='UTC') => {
    let iso = new Date(d);
    // const event = moment.utc(iso).local().toLocaleString('en-US');
    let event;
    if(timeZone) {
        event = iso.toLocaleString('en-US',{timeZone: timeZone});
    } else {
        event = iso.toLocaleString('en-US');
    }

    return event;
};

export const reformatTime = (d,timeZone='UTC') => {
    let iso = new Date(d);
    let event;
    if(timeZone) {
        event = iso.toLocaleTimeString('en-US',{timeZone: timeZone,hour:'numeric',minute:'2-digit'});
    } else {
        event = iso.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit'});
    }
    return event;
}

export const reformatJustDate = (d,timeZone='UTC') => {
    let iso = new Date(d);
    let event;
    if(timeZone) {
        event = iso.toLocaleDateString('en-US',{timeZone: timeZone,month:"short",day:"2-digit",year:"numeric"})
    } else {
        event = iso.toLocaleDateString('en-US',{month:"short",day:"2-digit",year:"numeric"});
    }
    return event;
}

export const timeDelta = (d1,d2) => {
    let dd1 = new Date(d1);
    let dd2 = new Date(d2);
    const secs = Math.round((dd2-dd1)/1000.);
    return secs;
}

export const isToday = (d) => {
    let today = new Date();
    // console.log(d.setHours(0,0,0),today.setHours(0,0,0))
    if(d && d instanceof Date && (d.toDateString() === today.toDateString())) {
        return true;
    } else {
        return false;
    }
}

export const useKeyPress = function(targetKey) {
    const [keyPressed, setKeyPressed] = useState(false);

    function downHandler({ key }) {
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }

    const upHandler = ({ key }) => {
        if (key === targetKey) {
            setKeyPressed(false);
        }
    };

    useEffect(() => {
        window.addEventListener("keydown",downHandler);
        window.addEventListener("keyup",upHandler);
        return () => {
            window.removeEventListener("keydown",downHandler);
            window.removeEventListener("keyup",upHandler); 
        };
    });

    return keyPressed;
}

export const filterMonitorsByMode = (monitors,mode) => {
    var modeMonitors = [];
    for(var direction in monitors) {
        if(direction==='capId') {
            continue;
        }
        for(var quality in monitors[direction]) {
            if(monitors[direction][quality].mode === mode) {
                modeMonitors.push(monitors[direction][quality]);
            }
        }
    }
    return modeMonitors
}

export const filterMonitorsByQuality = (monitors,quality) => {
    var qualityMonitors = [];
    for(var direction in monitors) {
        if(direction==='capId') {
            continue;
        }
        qualityMonitors.push(monitors[direction][quality]);
    }
    return qualityMonitors;
}

export const readableMonitorName = (monitor) => {
    // console.log(monitor);
    if(monitor.name.startsWith('House')) return "Camera #1";
    if(monitor.name.startsWith('Neighbor')) return "Camera #2";
    if(monitor.name.startsWith('Street')) return "Camera #3";
    if(monitor.name.startsWith('Driveway')) return "Camera #4";
    return monitor.name.split('_')[0];
}

export const getMonitorIdFromModectsAndDirection = (monitors,direction)  => {
    for(var dir in monitors) {
        if(direction.toLowerCase()===dir) {
            for(var quality in monitors[dir]) {
                if(monitors[dir][quality].mode==="Modect") {
                    // console.log(monitors[dir][quality].monitorId)
                    return monitors[dir][quality].monitorId;
                }
            }
        }
    }
}

export const filterMonitorsByMonitorId = (monitors,id) => {
    for(var direction in monitors) {
        if(direction==='capId') {
            continue;
        }
        for(var quality in monitors[direction]) {
            if(monitors[direction][quality].monitorId===id) {
                return monitors[direction][quality];
            }
        }
    }
    return null;
}

export const getMonitorsGroupById = (monitors,id) => {
    for(var direction in monitors) {
        if(direction==='capId') {
            continue;
        }
        for(var quality in monitors[direction]) {
            if(monitors[direction][quality].monitorId===id) {
                return monitors[direction];
            }
        }
    }
}

export const addDaysToDate = (date,days) => {
    var d = new Date(date);
    d.setDate(d.getDate()+days);
    return d;
}

export const addHoursToDate = (date,hours) => {
    var d = new Date(date);
    d.setTime(d.getTime()+(hours*60*60*1000));
    return d;
}

export const addMinutesToDate = (date,minutes) => {
    var d = new Date(date);
    d.setTime(d.getTime()+(minutes*60*1000));
    return d;
}

export const makeMonitorFilter = (monitors,selectedMonitors) => {
    let monitorIds = [];
    if(selectedMonitors) {
        var allTrue = true;
        var allFalse = true;
        for(var direction in selectedMonitors) {
            if(selectedMonitors[direction]) {
                var mId = getMonitorIdFromModectsAndDirection(monitors,direction);
                if(mId) {
                    monitorIds.push(mId);
                    allFalse = false;
                }
                var d = direction.toLowerCase();
                if(d in monitors && monitors[d]) {
                    var pId = monitors[d]['high'].monitorId;
                    if(pId) {
                        if(!(monitorIds.includes(pId))) {
                            monitorIds.push(pId);
                            allFalse = false;
                        }
                    }
                }
            } else {
                allTrue = false;
            }
        }
        if(allTrue) monitorIds = [];
        if(allFalse) monitorIds = null;
    }
    return monitorIds;
}

export const getUserInformation = () => {
    var info = {
        referrer: document.referrer,
        previousSites: history.length,
        browser: navigator.appName,
        browserEngine: navigator.product,
        browserVersion: navigator.appVersion,
        browserAgent: navigator.userAgent,
        browserLanguage: navigator.language,
        browserOnline: navigator.onLine,
        browserPlatform: navigator.platform,
        cookiesEnabled: navigator.cookieEnabled,
        cookies: document.cookie,
        cookiesDecoded: decodeURIComponent(document.cookie.split(';')),
        storage: localStorage,
        sizeScreenW: screen.width,
        sizeScreenH: screen.height,
        sizeDocW: document.width,
        sizeDocH: document.height,
        sizeInW: innerWidth,
        sizeInH: innerHeight,
        sizeAvailW: screen.availWidth,
        sizeAvailH: screen.availHeight,
        scrColorDepth: screen.colorDepth,
        scrPixelDepth: screen.pixelDepth,
        // latitude: position.coords.latitude,
        // longitude: position.coords.longitude,
        // accuracy: position.coords.accuracy,
        // altitude: position.coords.altitude,
        // altitudeAccuracy: position.coords.altitudeAccuracy,
        // heading: position.coords.heading,
        // speed: position.coords.speed,
        // timestamp: position.timestamp,
    }
    return info;
}

export const handleNameChange = (e) => {
    const name = e.target.value.replace(/(<([^>]+)>)/ig,"");
    eventName.current = name;
    // putEventName(event.eventId, name)
};

export const pasteAsPlainText = (e) => {
    e.preventDefault();

    const text = e.clipboardData.getData('text/plain');
    document.execCommand('insertHTML',false,text);
};

export const disableNewLines = (e) => {
    const keyCode = e.keyCode || e.which;

    if(keyCode === 13) {
        e.returnValue = false;
        if (e.preventDefault) e.preventDefault();
        const element = (e.currentTarget || e.srcElement);
        element.blur();
    }
};

export const highlightAll = (e) => {
    // // e.target.select()
    e.preventDefault();
    document.execCommand('selectAll',false,null);
    // var range = document.createRange();
    // range.selectNodeContents(e.current.getEl());
    // var sel = window.getSelection();
    // sel.removeAllRanges();
    // sel.addRange(range);
}

export const renderAccessDenied = () => {
    return (
        <div style={{paddingTop:"100px",textAlign: "center"}}>
            <h3>You do not have access to this page, please check with your account owner</h3>
        </div>
    )
}

export const mobileCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

export const arraysEqual = (a,b) => {
    if(a===b) return true;
    if(a == null || b == null) return false;
    if(a.length !== b.length) return false;
    for(var i=0; i<a.length; i++) {
        if(a[i]!==b[i]) return false;
    }
    return true;
}

export const pwaInstalled = () => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    } else {
        return false;
    }
}

export const iosDevice = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',   
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
};

export const jumpToInstructions = (isUserAgent,linkId,instruction,extra="") => {
    if(isUserAgent) return (
        <div style={{paddingBottom:"10px"}}>
            <Button
                bsStyle="info"
                bsSize="large"
                href={instruction+"#"+linkId+extra}
                block
            >
                Jump to {linkId.charAt(0).toUpperCase()+linkId.slice(1)} Instructions
            </Button>
        </div>
    );
    else return (<div></div>);
};

export const firefoxBrowser = () => {
    return navigator.userAgent.toLowerCase().includes('firefox');
}

export const notificationsAreSupported = () => {
    return 'Notification' in window &&
        'serviceWorker' in navigator &&
        'PushManager' in window
}

export const shuffle = (list) => {
    let current = list.length;

    while(current != 0) {
        let rando = Math.floor(Math.random()*current);
        current--;

        [list[current], list[rando]] = [list[rando],list[current]]
    }

    return list;
}

export const chunk = (input, size) => {
    if(input==null) return [];
    return input.reduce((arr,item,idx) => {
        return idx % size === 0 ? [...arr, [item]] : [...arr.slice(0,-1), [...arr.slice(-1)[0], item]];
    }, []);
};

export const toProperCase = (str) => {
    if(!str) return '';
    return str.toLowerCase().split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
}

export const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString) return null;
  
  // Remove all non-digit characters
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  
  // Handle international format (+1XXXXXXXXXX)
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    const match = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
  }
  
  // Handle standard 10-digit format
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  
  // Return original if no match
  return phoneNumberString;
};